function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import SearchBar from "../SearchBar";
import DatePicker from "react-datepicker";
var projectSchema = Yup.object().shape({
  projectName: Yup.string().trim().required("Required"),
  projectTime: Yup.number().positive().min(0, "only positive value")
  //projectManagers: Yup.array().of(Yup.string()).min(1, "Required atleast 1 option").required("Required atleast 1 option"),
});
function validateReportOf(value) {
  var error;
  if (!value) {
    error = "Required";
  } else if (value.length < 1) {
    error = "Required atleast 1 option";
  }
  return error;
}
export var ProjectModal = /*#__PURE__*/React.memo(function (props) {
  var _tasksOptionsData$get;
  var projectModalShow = props.projectModalShow,
    handleClose = props.handleClose,
    timeZone = props.timeZone,
    teamActive = props.teamActive,
    setTeamActive = props.setTeamActive,
    searchTeam = props.searchTeam,
    setSearchTeam = props.setSearchTeam,
    isTeamSelected = props.isTeamSelected,
    setTeamSelected = props.setTeamSelected,
    editProjectAndDeleteProject = props.editProjectAndDeleteProject,
    editProjectAndDeleteProjectLoading = props.editProjectAndDeleteProjectLoading,
    handleEditProject = props.handleEditProject,
    projectSelectedHeadList = props.projectSelectedHeadList,
    tasksOptionsData = props.tasksOptionsData,
    tasksOptionsLoading = props.tasksOptionsLoading,
    keyData = props.keyData,
    setKeyData = props.setKeyData,
    isCheck = props.isCheck,
    setIsCheck = props.setIsCheck,
    userContext = props.user,
    startTime = props.startTime,
    endTime = props.endTime,
    userAdminIds = props.userAdminIds,
    setUserAdminIds = props.setUserAdminIds,
    currenciesData = props.currenciesData,
    manualStartDate = props.manualStartDate,
    setManualStartDate = props.setManualStartDate,
    isManualDatePickerOpen = props.isManualDatePickerOpen,
    setIsManualDatePickerOpen = props.setIsManualDatePickerOpen,
    setManualDate = props.setManualDate,
    manualDate = props.manualDate,
    dateError = props.dateError,
    setDateError = props.setDateError;
  if (projectModalShow === null) {
    return null;
  }
  var modalType = projectModalShow.modalType,
    organisationId = projectModalShow.organisationId,
    projectName = projectModalShow.projectName,
    projectId = projectModalShow.projectId,
    selectedTeam = projectModalShow.selectedTeam,
    teamId = projectModalShow.teamId,
    startDate = projectModalShow.startDate,
    endDate = projectModalShow.endDate,
    projectTimeInSec = projectModalShow.projectTimeInSec,
    budget = projectModalShow.budget,
    projectDeadline = projectModalShow.projectDeadline;
  var userDetails = tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get = tasksOptionsData.getProjectUserDetails) === null || _tasksOptionsData$get === void 0 ? void 0 : _tasksOptionsData$get.teamUserList;
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (team) {
    return team.userId;
  });

  // const teamWithSearch = (teamData) => {
  //   if (!searchTeam) {
  //     return teamData;
  //   }

  //   return teamData.filter((filterteamData) => filterteamData?.name?.toLowerCase().includes(searchTeam.toLowerCase()));
  // };

  var userWithSearch = function userWithSearch(userData) {
    if (!searchTeam) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchTeam.toLowerCase());
    });
  };
  var projectTimeInHours = Math.round(Number(projectTimeInSec) / 3600);

  // const projectManagersOnChange = (setFieldValue) => (selectedArray) => {
  //   if (selectedArray && selectedArray.some((el) => el.value === "everyone")) {
  //     setFieldValue("projectManagers", ["everyone"]);
  //   } else if (selectedArray && selectedArray.some((el) => el.value === "all teams")) {
  //     setFieldValue("projectManagers", ["all teams"]);
  //   } else if (selectedArray && !selectedArray.some((el) => el.value === "everyone" || el.value === "all teams")) {
  //     setFieldValue(
  //       "projectManagers",
  //       selectedArray.map((item) => item.value)
  //     );
  //   } else {
  //     setFieldValue("projectManagers", []);
  //   }
  // };

  var handleKey = function handleKey(key) {
    setKeyData(key);
    setIsCheck(function (prev) {
      return prev === true ? false : true;
    });
  };

  // const handleChange = (e) => {
  //   setIsManualDatePickerOpen(!isManualDatePickerOpen);
  //   setManualStartDate(e);
  // };
  // const handleStartChange = (e) => {
  //   setManualDate(e);
  // }
  var handleStartChange = function handleStartChange(date) {
    setManualDate(date);
    if (manualStartDate && date && date > manualStartDate) {
      setDateError("Start date cannot be after the deadline.");
    } else {
      setDateError("");
    }
  };
  var handleChange = function handleChange(date) {
    setManualStartDate(date);
    if (manualDate && date && date < manualDate) {
      setDateError("Deadline must be after the start date.");
    } else {
      setDateError("");
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, "Edit Project Details")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "my-projects-edit-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      projectName: projectName,
      projectTime: projectTimeInHours ? projectTimeInHours : "",
      // team: "",
      // projectManagers: projectSelectedHeadList,
      // team: "",
      budget: budget ? budget : ""
    },
    validationSchema: projectSchema,
    onSubmit: handleEditProject
  }, function (_ref) {
    var _userWithSearch, _userWithSearch2;
    var setFieldValue = _ref.setFieldValue,
      errors = _ref.errors,
      touched = _ref.touched;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "projectName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field my-projects-modal-content-name-field-edit"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Project Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "text",
        placeholder: "Enter project name",
        className: "my-projects-edit-project-label-input"
      }, field)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "projectTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field my-projects-modal-content-name-field-edit"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Estimated Time (Optional)"), /*#__PURE__*/React.createElement("div", {
        className: "my-project-add-new-project-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "number",
        min: "0",
        placeholder: "Enter estimated hours",
        className: "my-projects-edit-project-label-input"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "my-project-add-new-project-hours-text"
      }, "Hours")));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "budget"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field my-projects-modal-content-name-field-edit"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Estimated Budget (Optional)"), /*#__PURE__*/React.createElement("div", {
        className: "my-project-add-new-project-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "number",
        min: "0",
        placeholder: "Enter estimated budget",
        className: "my-projects-edit-project-label-input"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "my-project-add-new-project-hours-text"
      }, currenciesData == "EUR" ? "€" : currenciesData == "GBP" ? "£" : currenciesData == "INR" ? "₹" : currenciesData == "BRL" ? "R$" : currenciesData == "ZAR" ? "R" : currenciesData == "SEK" ? "kr" : currenciesData == "NGN" ? "₦" : currenciesData == "PHP" ? "₱" : currenciesData == "MYR" ? "RM" : currenciesData == "SGD" ? "S$" : currenciesData == "LKR" ? "Rs" : "$")));
    })), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name-field"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "my-projects-modal-label-name"
    }, "Project Start Date (Optional)"), /*#__PURE__*/React.createElement(DatePicker, {
      id: "task-start-date",
      dateFormat: "dd/MM/yyyy",
      selected: manualDate,
      onChange: handleStartChange,
      isClearable: true,
      className: "task-details-due-date-date-picker edit-project-deadline-picker",
      placeholderText: "Select a date",
      autoComplete: "off",
      maxDate: manualStartDate || null // Prevent selecting after deadline
    }))), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-name-field"
    }, /*#__PURE__*/React.createElement(ControlLabel, {
      className: "my-projects-modal-label-name"
    }, "Project Deadline (Optional)"), /*#__PURE__*/React.createElement(DatePicker, {
      id: "task-due-date",
      dateFormat: "dd/MM/yyyy",
      selected: manualStartDate,
      onChange: handleChange,
      isClearable: true,
      className: "task-details-due-date-date-picker edit-project-deadline-picker",
      placeholderText: "Select a date",
      autoComplete: "off"
      // open={isManualDatePickerOpen}
      // inline
      ,
      minDate: manualDate || null // Prevent selecting before start date
    }))), dateError && /*#__PURE__*/React.createElement("div", {
      style: {
        color: "red",
        marginTop: "8px",
        fontSize: "0.875rem"
      }
    }, dateError), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-headers"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section-label my-projects-modal-content-person-name-header-section-label-edit"
    }, "Choose Project Members"))), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-edit-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-header-section-label"
    }), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-header-section-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(SearchBar, {
      value: searchTeam,
      onChange: setSearchTeam,
      placeholder: "Search employee name"
    })), userAdminIds.length != (teamActive === null || teamActive === void 0 ? void 0 : teamActive.length) ? (teamActive === null || teamActive === void 0 ? void 0 : teamActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setTeamActive([]);
        setTeamSelected(false);
      }
    }, "Unselect All") : /*#__PURE__*/React.createElement("p", {
      //variant="outline-secondary"
      className: "projects-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setTeamActive(userIds);
        setTeamSelected(true);
      }
    }, "Select All") : null))), /*#__PURE__*/React.createElement("div", {
      className: "project-details-tasks-modal-content-person-name-listing"
    }, tasksOptionsLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch = userWithSearch(userDetails)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(userDetails)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
      var teamFirstName = user.displayName.match(/\b(\w)/g);
      var teamNameIcon = teamFirstName.join("");

      // if (
      //   user.userId == userContext.userId &&
      //   user.roleId == "24e4b513-da16-44e8-92ff-d28fcdc0d17f"
      // ) {
      //   setUserAdminIds(user.userId);
      // }

      return /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person",
        onClick: function onClick() {
          if (user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
            setTeamSelected(true);
            setTeamActive(function (prev) {
              return prev.includes(user.userId) ? prev.filter(function (a) {
                return a !== user.userId;
              }) : [].concat(_toConsumableArray(prev), [user.userId]);
            });
          }
        }
      }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "task-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: user === null || user === void 0 ? void 0 : user.profileUrl,
        className: "task-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "tasks-modal-content-person-name-listing-card-content-person-icon"
      }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-header-team-name"
      }, user.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "my-projects-modal-content-team-name"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: user.userId,
        name: "myRadioGroup",
        className: "create-project-team-selection-control-checkbox",
        checked: user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? teamActive.includes(user.userId) : true,
        disabled: user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f" ? false : true,
        onChange: function onChange() {
          if (user.userId != userContext.userId && user.roleId != "24e4b513-da16-44e8-92ff-d28fcdc0d17f") {
            setTeamSelected(true);
            setTeamActive(function (prev) {
              return prev.includes(user.userId) ? prev.filter(function (a) {
                return a !== user.userId;
              }) : [].concat(_toConsumableArray(prev), [user.userId]);
            });
          }
        }
      })));
    }) : /*#__PURE__*/React.createElement("div", {
      className: "text-muted text-center"
    }, "No member found for \"".concat(searchTeam, "\"")))), !userAdminIds.length && !isTeamSelected ? /*#__PURE__*/React.createElement("div", {
      className: "create-project-team-selection-error-message"
    }, "Select at least one team member") : null)), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary"
      // onClick={handleClose}
      ,
      className: "my-projects-modal-save-button",
      type: "submit",
      disabled: editProjectAndDeleteProjectLoading
    }, editProjectAndDeleteProjectLoading ? "Loading..." : "Save Changes")))))));
  })));
});
export var DeleteProjectModal = /*#__PURE__*/React.memo(function (props) {
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose,
    editProjectAndDeleteProject = props.editProjectAndDeleteProject,
    editProjectAndDeleteProjectLoading = props.editProjectAndDeleteProjectLoading,
    handleDeleteProject = props.handleDeleteProject,
    projectDeleteStatus = props.projectDeleteStatus,
    projectType = props.projectType;
  if (showDeleteModal === null) {
    return null;
  }
  var organisationId = showDeleteModal.organisationId,
    projectName = showDeleteModal.projectName,
    projectId = showDeleteModal.projectId,
    teamId = showDeleteModal.teamId,
    startDate = showDeleteModal.startDate,
    endDate = showDeleteModal.endDate;
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Project")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, projectType == "automatic" ? "This is a default project. You can't delete it " : /*#__PURE__*/React.createElement(React.Fragment, null, "Do you want to remove the ", /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-card-delete-task-name"
  }, projectName, "?"), " ", "You will lose all of your project data, including tasks and their histories if you do this.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, "Cancel"), projectType == "automatic" ? null : /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteProject("inactive", projectId),
    disabled: editProjectAndDeleteProjectLoading
  }, projectDeleteStatus === true ? "Deleted" : editProjectAndDeleteProjectLoading ? "Loading" : "Delete Project")));
});
export var ArchiveProjectModal = /*#__PURE__*/React.memo(function (props) {
  var showArchiveModal = props.showArchiveModal,
    handleArchiveClose = props.handleArchiveClose,
    editProjectAndDeleteProject = props.editProjectAndDeleteProject,
    editProjectAndDeleteProjectLoading = props.editProjectAndDeleteProjectLoading,
    handleArchiveProject = props.handleArchiveProject,
    projectArchiveStatus = props.projectArchiveStatus,
    archiveStatus = props.archiveStatus,
    projectType = props.projectType;
  if (showArchiveModal === null) {
    return null;
  }
  var organisationId = showArchiveModal.organisationId,
    projectName = showArchiveModal.projectName,
    projectId = showArchiveModal.projectId,
    teamId = showArchiveModal.teamId,
    startDate = showArchiveModal.startDate,
    endDate = showArchiveModal.endDate;
  return /*#__PURE__*/React.createElement(Modal, {
    show: showArchiveModal,
    onHide: handleArchiveClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Archive Project")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, projectType == "automatic" ? "This is a default project. You can't archive it " : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, " ", archiveStatus == "archive" ? "Are you sure to unarchive this ".concat(projectName, "?") : "Are you sure to archive this ".concat(projectName, "?")))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleArchiveClose
  }, "Cancel"), projectType == "automatic" ? null : archiveStatus == "archive" ? /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleArchiveProject("unArchive", projectId),
    disabled: editProjectAndDeleteProjectLoading
  },
  // projectArchiveStatus === true
  //   ? "UnArchived"
  //   : 
  editProjectAndDeleteProjectLoading ? "Loading" : "UnArchive Project") : /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleArchiveProject("archive", projectId),
    disabled: editProjectAndDeleteProjectLoading
  },
  // projectArchiveStatus === true
  //   ? "Archived"
  // : 
  editProjectAndDeleteProjectLoading ? "Loading" : "Archive Project")));
});